const types = {};

types.SET_LIST = 'SET_LIST';
types.ADD_TO_LIST = 'ADD_TO_LIST';
types.EDIT_ITEM = 'EDIT_ITEM';
types.SET_EMAIL_SERVICE_NAME = 'SET_EMAIL_SERVICE_NAME';
types.SET_EMAIL_SERVICE_TYPE = 'SET_EMAIL_SERVICE_TYPE';
types.SET_EMAIL_SERVICE_CONFIG = 'SET_EMAIL_SERVICE_CONFIG';
types.SET_ACTIVE = 'SET_ACTIVE';
types.RESET_ACTIVE = 'RESET_ACTIVE';
types.REMOVE_ITEM = 'REMOVE_ITEM';

export default types;



// WEBPACK FOOTER //
// ./src/screens/Account/store/types.js